import floorDeepA from "@/assets/sprites/terrain/floors/floor-deep-a.svg";
import floorDeepB from "@/assets/sprites/terrain/floors/floor-deep-b.svg";
import floorDeepC from "@/assets/sprites/terrain/floors/floor-deep-c.svg";
import floorGrassA from "@/assets/sprites/terrain/floors/floor-grass-a.svg";
import floorGrassB from "@/assets/sprites/terrain/floors/floor-grass-b.svg";
import floorGrassC from "@/assets/sprites/terrain/floors/floor-grass-c.svg";
import floorGrassSunlight from "@/assets/sprites/terrain/floors/floor-grass-sunlight.svg";
import floorNestA from "@/assets/sprites/terrain/floors/floor-nest-a.svg";
import floorNestB from "@/assets/sprites/terrain/floors/floor-nest-b.svg";
import floorNestC from "@/assets/sprites/terrain/floors/floor-nest-c.svg";
import floorSandA from "@/assets/sprites/terrain/floors/floor-sand-a.svg";
import floorSandB from "@/assets/sprites/terrain/floors/floor-sand-b.svg";
import floorSandC from "@/assets/sprites/terrain/floors/floor-sand-c.svg";
import floorSewerA from "@/assets/sprites/terrain/floors/floor-sewer-a.svg";
import floorSewerB from "@/assets/sprites/terrain/floors/floor-sewer-b.svg";
import floorSewerC from "@/assets/sprites/terrain/floors/floor-sewer-c.svg";
import floorWoodA from "@/assets/sprites/terrain/floors/floor-wood-a.svg";
import floorWoodFlower from "@/assets/sprites/terrain/floors/floor-wood-flower.svg";
import floorWoodGrass from "@/assets/sprites/terrain/floors/floor-wood-grass.svg";
import floorWoodStone from "@/assets/sprites/terrain/floors/floor-wood-stone.svg";
import floorVolcanoA from "@/assets/sprites/terrain/floors/floor-volcano-a.svg";
import floorVolcanoB from "@/assets/sprites/terrain/floors/floor-volcano-b.svg";
import floorVolcanoC from "@/assets/sprites/terrain/floors/floor-volcano-c.svg";
import raidFloorGrass from "@/assets/sprites/terrain/raid-floor-grass.svg";
import raidFloorLeaves from "@/assets/sprites/terrain/raid-floor-leaves.svg";
import raidFloorPlanks from "@/assets/sprites/terrain/raid-floor-planks.svg";
import raidGap from "@/assets/sprites/terrain/raid-gap.svg";
import raidTombstone from "@/assets/sprites/terrain/raid-tombstone.svg";
import raidTreeStump from "@/assets/sprites/terrain/raid-tree-stump.svg";
import raidWaterBlue from "@/assets/sprites/terrain/raid-water-blue.svg";
import raidWaterMurky from "@/assets/sprites/terrain/raid-water-murky.svg";
import trap from "@/assets/sprites/terrain/trap.svg";
import wall from "@/assets/sprites/terrain/wall.svg";
import water from "@/assets/sprites/terrain/water.svg";
import clayBrick from "@/assets/sprites/terrain/clay-brick.svg";
import miningFloor from "@/assets/sprites/terrain/mining-floor.svg";
import miningWall from "@/assets/sprites/terrain/mining-wall.svg";
import miningFloor2 from "@/assets/sprites/terrain/mining-floor-2.svg";
import miningFloor3 from "@/assets/sprites/terrain/mining-floor-3.svg";
import miningFloor4 from "@/assets/sprites/terrain/mining-floor-4.svg";
import miningFloor5 from "@/assets/sprites/terrain/mining-floor-5.svg";
import miningWall2 from "@/assets/sprites/terrain/mining-wall-2.svg";
import miningWall3 from "@/assets/sprites/terrain/mining-wall-3.svg";
import miningWall4 from "@/assets/sprites/terrain/mining-wall-4.svg";
import miningWall5 from "@/assets/sprites/terrain/mining-wall-5.svg";
import volcanicWall from "@/assets/sprites/terrain/volcanic-wall.svg";
import fireBeam from "@/assets/sprites/terrain/fire-beam.svg";
import fireBeamCross from "@/assets/sprites/terrain/fire-beam-cross.svg";
import floorForgeA from "@/assets/sprites/terrain/floors/floor-forge-a.svg";
import floorForgeB from "@/assets/sprites/terrain/floors/floor-forge-b.svg";
import forgeWall from "@/assets/sprites/terrain/forge-wall.svg";
import floorTowerPath from "@/assets/sprites/terrain/floors/floor-tower-path.svg";
import raidFloorAbyssalMetal from "@/assets/sprites/terrain/raid-floor-abyssal-metal.svg";
import raidFloorSand from "@/assets/sprites/terrain/raid-floor-sand.svg";
import raidWaterOcean from "@/assets/sprites/terrain/raid-water-ocean.svg";
import raidPressureVat from "@/assets/sprites/terrain/raid-pressure-vat.svg";

export const terrainSprites = {
  floorDeepA, floorDeepB, floorDeepC,
  floorGrassA, floorGrassB, floorGrassC, floorGrassSunlight,
  floorNestA, floorNestB, floorNestC,
  floorSandA, floorSandB, floorSandC,
  floorSewerA, floorSewerB, floorSewerC,
  floorWoodA, floorWoodFlower, floorWoodGrass, floorWoodStone,
  floorVolcanoA, floorVolcanoB, floorVolcanoC,
  raidFloorPlanks, raidFloorGrass, raidTombstone, raidFloorLeaves, raidTreeStump,
  raidGap, raidWaterMurky, raidWaterBlue,
  water, wall, trap, clayBrick,
  miningFloor, miningFloor2, miningFloor3, miningFloor4, miningFloor5,
  miningWall, miningWall2, miningWall3, miningWall4, miningWall5,
  volcanicWall, fireBeam, fireBeamCross,
  floorForgeA, floorForgeB, forgeWall,
  floorTowerPath,
  raidFloorAbyssalMetal, raidFloorSand, raidWaterOcean, raidPressureVat,
} as const;
